<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="tablePath">自选职业推送列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               :disabled="disabled"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="推送标题"
                          prop="title">
              <el-input v-model="form.title" placeholder="建议十字以内,例：欢迎使用爱零工、欢迎回来" />
            </el-form-item>
            <el-form-item label="推送文案"
                          prop="detail">
              <el-input v-model="form.detail"
                        :rows="4"
                        placeholder="建议十五字以内，例：请选择您的职业以便我们更好的为您服务"
                        type="textarea" />
            </el-form-item>
            <el-form-item label="推送开始/结束时间"
                          prop="cycle">
              <el-date-picker
                v-model="form.cycle"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                :picker-options="dateTimePickerRangeOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="选择推送职业"
                          prop="occupations">
              <sj-form-subsets :default-value="() => ({id: null})"
                               :form-rules="occupationRules"
                               :disabled="disabled"
                               @appended="onAddOccupation"
                               v-model="form.occupations">
                <template slot-scope="scope">
                  <el-form-item prop="id"
                                :label="'职业' + (scope.index + 1)">
                    <sj-remote-select
                      clearable
                      id-key="id"
                      keyword-key="name"
                      label-key="name"
                      value-key="id"
                      placeholder="输入职业关键字搜索"
                      v-model="scope.value.id"
                      :remote-method="getOccupationTable">
                    </sj-remote-select>
                  </el-form-item>
                </template>
              </sj-form-subsets>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <template v-if="!disabled">
            <el-button type="primary"
                       native-type="submit">提交表单
            </el-button>
              <el-button @click="onReload">重置</el-button>
          </template>
        </el-form-item>
      </el-form>
    </layout-panel>
    <router-link :to="tablePath" v-if="disabled">
      <el-button type="primary">返回</el-button>
    </router-link>
  </div>
</template>

<script>
import { formRules, occupationRules } from '../occupation-questionnaire.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import SjFormSubsets from '../components/SjFormSubsets'

export default {
  mixins: [dateTimePicker],
  components: {
    SjFormSubsets
  },
  data () {
    return {
      id: 0,
      formRules,
      occupationRules,
      form: {
        title: '',
        detail: null,
        cycle: [],
        starttime: null,
        endtime: null,
        occupations: []
      },
      detail: null,
      tablePath: '/users/occupation-questionnaire/table'
    }
  },
  computed: {
    disabled () {
      return this.detail && this.detail.status !== 1
    }
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    ...request.map(['getOccupationTable', 'getOccupationDetail']),
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getOccupationQuestionnaireDetail', {id}).then(({data}) => {
        this.form.cycle = [data.starttime, data.endtime]
        filter.setLoop(this.form, data)

        this.detail = data
      })
    },
    getForm () {
      let form = filter.copyJson(this.form)
      form.starttime = form.cycle[0]
      form.endtime = form.cycle[1]
      delete form.cycle
      return form
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      request.common('createOccupationQuestionnaireData', this.getForm()).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({path: this.tablePath})
        })
      })
    },
    update (id) {
      request.common('updateOccupationQuestionnaireData', {id, ...this.getForm()}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: this.tablePath})
        })
      })
    },
    onAddOccupation (formItem) {
      formItem.$children[1].$children[0].$refs['reference'].focus()
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/occupation-questionnaire/pages/OccupationQuestionnaireForm.vue